import { render } from "./SexyButton.vue?vue&type=template&id=710af9ae"
import script from "./SexyButton.vue?vue&type=script&lang=js"
export * from "./SexyButton.vue?vue&type=script&lang=js"

import "./SexyButton.vue?vue&type=style&index=0&id=710af9ae&lang=css"
script.render = render

export default script